export default "__VITE_ASSET__Bgl8WIV4__"